interface Props {
  eyebrow: string;
  title: string[];
  lead?: string;
}

/** Sidhuvud för undersidor. Titeln bryts på de rader som anges i arrayen. */
export default function PageHero({ eyebrow, title, lead }: Props) {
  return (
    <section className="page-hero">
      <p className="eyebrow">{eyebrow}</p>
      <h1>
        {title.map((line, index) => (
          <span key={line}>
            {line}
            {index < title.length - 1 && <br />}
          </span>
        ))}
      </h1>
      {lead && <p className="lead">{lead}</p>}
    </section>
  );
}
